module.exports = __webpack_public_path__ + "static/media/Luis.0d983cef.jpg";